import { createClient } from "@supabase/supabase-js";

// Supabase publishable keys are intentionally safe for browser bundles. These
// production fallbacks keep authentication connected during direct Cloudflare
// deployments while still allowing local/preview environments to override
// them. Never place the service-role key in this client module.
const url =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ||
  "https://jiuqxfpijijxvnyrqtsp.supabase.co";
const anonKey =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ||
  "sb_publishable_JbfbIOnqlAnm2jXybN_qcA_WmURLSgS";

export const isSupabaseConfigured = Boolean(url && anonKey);

export function edgeFunctionUrl(name: string) {
  return `${url.replace(/\/$/, "")}/functions/v1/${name}`;
}
export const supabase = isSupabaseConfigured
  ? createClient(url!, anonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export async function sendMagicLink(
  email: string,
  redirectPath = "/dashboard",
  shouldCreateUser = true,
  captchaToken?: string,
) {
  if (!supabase) throw new Error("Membership sign-in is being connected.");
  return supabase.auth.signInWithOtp({
    email,
    options: {
      shouldCreateUser,
      emailRedirectTo: `${window.location.origin}${redirectPath}`,
      captchaToken,
    },
  });
}

export async function signInWithEmailPassword(
  email: string,
  password: string,
  captchaToken?: string,
) {
  if (!supabase) throw new Error("Staff sign-in is being connected.");
  return supabase.auth.signInWithPassword({
    email,
    password,
    options: { captchaToken },
  });
}

export async function sendPasswordReset(
  email: string,
  redirectPath = "/staff?reset-password=1",
  captchaToken?: string,
) {
  if (!supabase) throw new Error("Staff sign-in is being connected.");
  const recoveryOrigin =
    window.location.hostname === "localhost"
      ? window.location.origin
      : "https://solocafe.in";
  return supabase.auth.resetPasswordForEmail(email, {
    redirectTo: `${recoveryOrigin}${redirectPath}`,
    captchaToken,
  });
}

export async function updateAccountPassword(password: string) {
  if (!supabase) throw new Error("Staff sign-in is being connected.");
  return supabase.auth.updateUser({ password });
}

export async function sendPhoneOtp(
  phone: string,
  captchaToken?: string,
  shouldCreateUser = true,
) {
  if (!supabase) throw new Error("Membership sign-in is being connected.");
  return supabase.auth.signInWithOtp({
    phone,
    options: { channel: "sms", captchaToken, shouldCreateUser },
  });
}

export async function verifyPhoneOtp(phone: string, token: string) {
  if (!supabase) throw new Error("Membership sign-in is being connected.");
  return supabase.auth.verifyOtp({ phone, token, type: "sms" });
}
